import { apiSlice } from "app/api/apiSlice"

export const usersApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['myUserInfo'],
    endpoints: builder => ({

        // GET my User Info
        getUserInfo: builder.query({
            query: () => 'user/info/me',
            keepUnusedDataFor: 5,
            providesTags: ['myUserInfo']
        }),

        // EDIT my User Info
        editUserInfo: builder.mutation({
            query: (payload) => ({
                url: 'user/me',
                method: 'PUT',
                body: payload,
                formData: true
            }),
            invalidatesTags: ['myUserInfo']
        }),
    })
})

export const {
    useGetUserInfoQuery,
    useEditUserInfoMutation
} = usersApiSlice 